import { trackingPageSchema } from "@redotech/redo-model/order-tracking/tracking-page-definition";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const getTrackingPageById = {
  name: "getTrackingPageById" as const,
  input: z.object({ id: zExt.objectId() }),
  output: trackingPageSchema.nullable(),
};
